<template>
  <div class="page-container products-page">
    <div id="TestContainer">
      <div class="box" v-for="(item, idx) in itemList" :key="'item_' + idx">
        <img :src="item.image" alt="">
        <!-- <h5>{{item.headline}}</h5> -->
      </div>
    </div>
  </div>
</template>

<script>
import product1 from "@/assets/products/products1.png"
import product2 from "@/assets/products/products2.png"
import product3 from "@/assets/products/products3.png"
import product4 from "@/assets/products/products4.png"
import product5 from "@/assets/products/products5.png"
import product6 from "@/assets/products/products6.png"
import product7 from "@/assets/products/products7.png"
import product8 from "@/assets/products/products8.png"
import product9 from "@/assets/products/products9.png"
import product10 from "@/assets/products/products10.png"
import product11 from "@/assets/products/products11.png"
import product12 from "@/assets/products/products12.png"

export default {
  name: 'products',
  components: {
  },
  data() {
    return {
      itemList: [
        {
          "image": product1
        },
        {
          "image": product2
        },
        {
          "image": product3
        },
        {
          "image": product4
        },
        {
          "image": product5
        },
        {
          "image": product6
        },
        {
          "image": product7
        },
        {
          "image": product8
        },
        {
          "image": product9
        },
        {
          "image": product10
        },
        {
          "image": product11
        },
        {
          "image": product12
        },
      ]
    }
  },
  components: {
  },
  mounted() {
  },

  setup() {
  }
}
</script>

<style scoped>
.products-page {
  background-color: #424245;
}
#TestContainer{
  margin: 24px auto;
  width: 95vw;
  background-color: #424245;
  /* 添加上多列布局 */
  column-fill: balance;
  column-count: 2;
  column-gap: 4;
}
.box {
  overflow: auto;
  margin-bottom: 8px;
}
.box>img{
  width: 100%;
  border-radius: 8px;
}
</style>
